export default {
  SAVE_ORGANISATION_ITEM(state, payload) {
    state.organisationItem = payload
  },
  SAVE_DIVISION_ITEM(state, payload) {
    state.divisionItem = payload
  },
  SAVE_POSITION_ITEM(state, payload) {
    state.positionItem = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/organisation/mutations.js